export default __webpack_public_path__ + "static/hw_led-32935f093fa8aa0fb3138e29f1f40c3f.jpg";